import { Directive, TemplateRef, Input, InjectionToken, Component, forwardRef, ChangeDetectorRef, ContentChildren, ViewChild, ViewContainerRef, ComponentFactoryResolver, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AwButtonModule } from '@aw/ads-components/aw-button';
import { BreakpointObserver } from '@angular/cdk/layout';
import { MultiColumnService } from '@aw/ads-components/src/services/multi-column';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/cdk/layout';
import * as ɵngcc2 from '@aw/ads-components/src/services/multi-column';
import * as ɵngcc3 from '@angular/common';

const _c0 = ["dynamicLoadingTemplate"];
const _c1 = ["staticLoadingTemplate"];
function AwMultiColumnContentComponent_div_0_ng_container_1_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
const _c2 = function (a0) { return { width: a0 }; };
function AwMultiColumnContentComponent_div_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 6);
    ɵngcc0.ɵɵelementStart(2, "div", 7);
    ɵngcc0.ɵɵtemplate(3, AwMultiColumnContentComponent_div_0_ng_container_1_ng_container_3_Template, 1, 0, "ng-container", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const column_r8 = ctx.$implicit;
    const i_r9 = ctx.index;
    const ctx_r7 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(3, _c2, ctx_r7.contentLayout[i_r9]));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", column_r8.templateRef)("ngTemplateOutletContext", column_r8);
} }
function AwMultiColumnContentComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵtemplate(1, AwMultiColumnContentComponent_div_0_ng_container_1_Template, 4, 5, "ng-container", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.renderedPanels);
} }
function AwMultiColumnContentComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0, 9);
} if (rf & 2) {
    const type_r11 = ctx.type;
    const context_r12 = ctx.context;
    ɵngcc0.ɵɵproperty("awDynamicLoading", type_r11)("context", context_r12);
} }
function AwMultiColumnContentComponent_ng_template_3_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function AwMultiColumnContentComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, AwMultiColumnContentComponent_ng_template_3_ng_container_0_Template, 1, 0, "ng-container", 8);
} if (rf & 2) {
    const context_r13 = ctx.context;
    const template_r14 = ctx.panelTemplate;
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", template_r14)("ngTemplateOutletContext", context_r13);
} }
function AwMultiColumnContentComponent_ng_template_5_ng_container_0_div_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function AwMultiColumnContentComponent_ng_template_5_ng_container_0_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 12);
    ɵngcc0.ɵɵtemplate(1, AwMultiColumnContentComponent_ng_template_5_ng_container_0_div_1_ng_container_1_Template, 1, 0, "ng-container", 8);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const templateMobile_r17 = ɵngcc0.ɵɵnextContext().ngIf;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", templateMobile_r17[templateMobile_r17.length - 1].templateRef)("ngTemplateOutletContext", templateMobile_r17[templateMobile_r17.length - 1]);
} }
function AwMultiColumnContentComponent_ng_template_5_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, AwMultiColumnContentComponent_ng_template_5_ng_container_0_div_1_Template, 2, 2, "div", 11);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const templateMobile_r17 = ctx.ngIf;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", templateMobile_r17.length > 0);
} }
function AwMultiColumnContentComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, AwMultiColumnContentComponent_ng_template_5_ng_container_0_Template, 2, 1, "ng-container", 10);
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.mobilePanels);
} }
class AwMultiColumnPanel {
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
}
AwMultiColumnPanel.ɵfac = function AwMultiColumnPanel_Factory(t) { return new (t || AwMultiColumnPanel)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef)); };
AwMultiColumnPanel.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: AwMultiColumnPanel, selectors: [["", "awMultiColumnPanel", ""]], inputs: { forDesktopOnly: ["awMultiColumnPanel", "forDesktopOnly"] } });
AwMultiColumnPanel.ctorParameters = () => [
    { type: TemplateRef }
];
AwMultiColumnPanel.propDecorators = {
    forDesktopOnly: [{ type: Input, args: ['awMultiColumnPanel',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AwMultiColumnPanel, [{
        type: Directive,
        args: [{ selector: '[awMultiColumnPanel]' }]
    }], function () { return [{ type: ɵngcc0.TemplateRef }]; }, { forDesktopOnly: [{
            type: Input,
            args: ['awMultiColumnPanel']
        }] }); })();

const MULTI_COLUMN_PROVIDER = new InjectionToken('AwMultiColumnProvider');
class AwMultiColumnContentComponent {
    constructor(breakpointObserver, multiColumnService, cdr) {
        this.breakpointObserver = breakpointObserver;
        this.multiColumnService = multiColumnService;
        this.cdr = cdr;
        this.panels = [];
        this.isMobileView = false;
        this.contentLayout = ['33.3333%', '66.66675%'];
        this.mobileBreakpoint = '(max-width: 991px)';
    }
    get panelCount() {
        return this.mobilePanels.length;
    }
    get mobilePanels() {
        return this.panels.filter((panel) => !panel.desktopOnly);
    }
    set contentLayoutParser(value) {
        this.contentLayout = value.split(':');
    }
    get renderedPanels() {
        return this.isMobileView ? this.mobilePanels : this.panels;
    }
    ngOnInit() {
        this.mobileScreenSubscription = this.breakpointObserver
            .observe(this.mobileBreakpoint)
            .subscribe((state) => {
            this.isMobileView = !!state.matches;
            this.cdr.markForCheck();
        });
    }
    ngAfterViewInit() {
        setTimeout(() => {
            if (this.layoutPanels.length > 0) {
                this.panels = this.layoutPanels.toArray().map((element) => ({ templateRef: this.staticLoadingTemplate, panelTemplate: element.templateRef, desktopOnly: element.forDesktopOnly }));
            }
            this.cdr.markForCheck();
        });
    }
    ngOnDestroy() {
        this.mobileScreenSubscription.unsubscribe();
    }
    setContext(context, index) {
        if (index < 0 || index >= this.panels.length) {
            console.error('Incorrect index for set context');
            return;
        }
        this.panels[index].context = context;
        this.cdr.markForCheck();
    }
    setTemplate(template, index, desktopOnly = false) {
        if (index < 0 || index > this.panels.length) {
            console.error('Incorrect index for set template');
            return;
        }
        if (template) {
            const params = { desktopOnly };
            if (template instanceof TemplateRef) {
                params.templateRef = this.staticLoadingTemplate;
                params.panelTemplate = template;
            }
            else {
                params.templateRef = this.dynamicLoadingTemplate;
                params.type = template;
            }
            this.panels[index] = Object.assign(Object.assign({}, (this.panels[index] || {})), params);
        }
        else {
            this.panels.splice(index, 1);
        }
        this.cdr.markForCheck();
    }
    removeLast() {
        if (this.panels.length <= 0) {
            console.error('Don\'t have any panel to remove');
            return;
        }
        if (this.isMobileView) {
            while (this.panels[this.panels.length] && this.panels[this.panels.length].desktopOnly) {
                this.panels.pop();
            }
        }
        this.panels.pop();
        this.cdr.markForCheck();
    }
}
AwMultiColumnContentComponent.ɵfac = function AwMultiColumnContentComponent_Factory(t) { return new (t || AwMultiColumnContentComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.BreakpointObserver), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.MultiColumnService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
AwMultiColumnContentComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AwMultiColumnContentComponent, selectors: [["aw-multi-column-content"]], contentQueries: function AwMultiColumnContentComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, AwMultiColumnPanel, false);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.layoutPanels = _t);
    } }, viewQuery: function AwMultiColumnContentComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, true);
        ɵngcc0.ɵɵviewQuery(_c1, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dynamicLoadingTemplate = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.staticLoadingTemplate = _t.first);
    } }, inputs: { contentLayoutParser: ["contentLayout", "contentLayoutParser"] }, features: [ɵngcc0.ɵɵProvidersFeature([{ provide: MULTI_COLUMN_PROVIDER, useExisting: forwardRef(() => AwMultiColumnContentComponent) }])], decls: 7, vars: 2, consts: [["class", "flex aw-row h100 m-b0", 4, "ngIf", "ngIfElse"], ["dynamicLoadingTemplate", ""], ["staticLoadingTemplate", ""], ["singleContent", ""], [1, "flex", "aw-row", "h100", "m-b0"], [4, "ngFor", "ngForOf"], [1, "col", 3, "ngStyle"], [1, "column-inner"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [3, "awDynamicLoading", "context"], [4, "ngIf"], ["class", "h100", 4, "ngIf"], [1, "h100"]], template: function AwMultiColumnContentComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, AwMultiColumnContentComponent_div_0_Template, 2, 1, "div", 0);
        ɵngcc0.ɵɵtemplate(1, AwMultiColumnContentComponent_ng_template_1_Template, 1, 2, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(3, AwMultiColumnContentComponent_ng_template_3_Template, 1, 2, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(5, AwMultiColumnContentComponent_ng_template_5_Template, 1, 1, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r5 = ɵngcc0.ɵɵreference(6);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.isMobileView)("ngIfElse", _r5);
    } }, directives: function () { return [ɵngcc3.NgIf, ɵngcc3.NgForOf, ɵngcc3.NgStyle, ɵngcc3.NgTemplateOutlet, AwDynamicLoadingTemplate]; }, encapsulation: 2 });
AwMultiColumnContentComponent.ctorParameters = () => [
    { type: BreakpointObserver },
    { type: MultiColumnService },
    { type: ChangeDetectorRef }
];
AwMultiColumnContentComponent.propDecorators = {
    layoutPanels: [{ type: ContentChildren, args: [AwMultiColumnPanel,] }],
    dynamicLoadingTemplate: [{ type: ViewChild, args: ['dynamicLoadingTemplate',] }],
    staticLoadingTemplate: [{ type: ViewChild, args: ['staticLoadingTemplate',] }],
    contentLayoutParser: [{ type: Input, args: ['contentLayout',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AwMultiColumnContentComponent, [{
        type: Component,
        args: [{
                selector: 'aw-multi-column-content',
                template: "<div class=\"flex aw-row h100 m-b0\" *ngIf=\"!isMobileView; else singleContent\">\n    <ng-container *ngFor=\"let column of renderedPanels, let i = index\">\n            <div class=\"col\"\n                [ngStyle]=\"{width: contentLayout[i]}\"\n                >\n                <div class=\"column-inner\" >\n                    <ng-container *ngTemplateOutlet=\"column.templateRef; context: column\">\n                    </ng-container>\n                </div>\n            </div>\n            \n    </ng-container>\n</div>\n\n<ng-template #dynamicLoadingTemplate let-type=\"type\" let-context=\"context\">\n    <ng-container [awDynamicLoading]=\"type\" [context]=\"context\"></ng-container>\n</ng-template>\n\n<ng-template #staticLoadingTemplate let-context=\"context\" let-template=\"panelTemplate\">\n    <ng-container *ngTemplateOutlet=\"template; context: context\"></ng-container>\n</ng-template>\n\n<ng-template #singleContent>\n    <ng-container *ngIf=\"mobilePanels as templateMobile\">\n        <div class=\"h100\" *ngIf=\"templateMobile.length>0\">\n            <ng-container *ngTemplateOutlet=\"templateMobile[templateMobile.length-1].templateRef; context: templateMobile[templateMobile.length-1]\">\n            </ng-container>\n        </div>\n    </ng-container>\n</ng-template>",
                providers: [{ provide: MULTI_COLUMN_PROVIDER, useExisting: forwardRef(() => AwMultiColumnContentComponent) }]
            }]
    }], function () { return [{ type: ɵngcc1.BreakpointObserver }, { type: ɵngcc2.MultiColumnService }, { type: ɵngcc0.ChangeDetectorRef }]; }, { contentLayoutParser: [{
            type: Input,
            args: ['contentLayout']
        }], layoutPanels: [{
            type: ContentChildren,
            args: [AwMultiColumnPanel]
        }], dynamicLoadingTemplate: [{
            type: ViewChild,
            args: ['dynamicLoadingTemplate']
        }], staticLoadingTemplate: [{
            type: ViewChild,
            args: ['staticLoadingTemplate']
        }] }); })();

class AwDynamicLoadingTemplate {
    constructor(viewContainer, componentFactoryResolver) {
        this.viewContainer = viewContainer;
        this.componentFactoryResolver = componentFactoryResolver;
    }
    ngOnInit() {
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(this.awDynamicLoading);
        this.viewContainer.clear();
        this.componentRef = this.viewContainer.createComponent(componentFactory);
        if (this.context && this.componentRef.instance.__setMultiLayoutContext) {
            this.componentRef.instance.__setMultiLayoutContext(this.context);
        }
    }
    ngOnChanges(changes) {
        if (changes.context && this.componentRef && this.componentRef.instance.__setMultiLayoutContext) {
            this.componentRef.instance.__setMultiLayoutContext(changes.context.currentValue);
        }
    }
}
AwDynamicLoadingTemplate.ɵfac = function AwDynamicLoadingTemplate_Factory(t) { return new (t || AwDynamicLoadingTemplate)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver)); };
AwDynamicLoadingTemplate.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: AwDynamicLoadingTemplate, selectors: [["", "awDynamicLoading", ""]], inputs: { awDynamicLoading: "awDynamicLoading", context: "context" }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
AwDynamicLoadingTemplate.ctorParameters = () => [
    { type: ViewContainerRef },
    { type: ComponentFactoryResolver }
];
AwDynamicLoadingTemplate.propDecorators = {
    awDynamicLoading: [{ type: Input }],
    context: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AwDynamicLoadingTemplate, [{
        type: Directive,
        args: [{
                selector: '[awDynamicLoading]'
            }]
    }], function () { return [{ type: ɵngcc0.ViewContainerRef }, { type: ɵngcc0.ComponentFactoryResolver }]; }, { awDynamicLoading: [{
            type: Input
        }], context: [{
            type: Input
        }] }); })();

class AwMultiColumnContentModule {
}
AwMultiColumnContentModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: AwMultiColumnContentModule });
AwMultiColumnContentModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function AwMultiColumnContentModule_Factory(t) { return new (t || AwMultiColumnContentModule)(); }, imports: [[
            CommonModule,
            AwButtonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AwMultiColumnContentModule, { declarations: function () { return [AwMultiColumnContentComponent, AwMultiColumnPanel, AwDynamicLoadingTemplate]; }, imports: function () { return [CommonModule,
        AwButtonModule]; }, exports: function () { return [AwMultiColumnContentComponent, AwMultiColumnPanel]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AwMultiColumnContentModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    AwButtonModule
                ],
                declarations: [
                    AwMultiColumnContentComponent,
                    AwMultiColumnPanel,
                    AwDynamicLoadingTemplate
                ],
                exports: [
                    AwMultiColumnContentComponent,
                    AwMultiColumnPanel
                ]
            }]
    }], null, null); })();

export { AwMultiColumnContentComponent, AwMultiColumnContentModule, AwMultiColumnPanel, MULTI_COLUMN_PROVIDER, AwDynamicLoadingTemplate as ɵa };

//# sourceMappingURL=aw-ads-components-aw-multi-column-content.js.map